
































import { Component, Vue } from 'vue-property-decorator';
import MaterialCard from '@/components/material/Card/index.vue';
import AccountListResult from '@/components/account/list/Result.vue';
import { formatApiError } from '@/utils/index';
import { translateRouteTitle } from '@/utils/permission';
import { AppModule } from '@/store/modules/app';
import { IExternalAccount, IGroup } from '@/api/types';
import {
  listAccounts,
  IListAccountsRequest,
  listGroups,
  IListGroupsRequest,
} from '@/api/users';

@Component({
  name: 'AccountList',
  components: {
    MaterialCard,
    AccountListResult,
  },
})
export default class extends Vue {
  private accounts: IExternalAccount[] = [];
  private groups: IGroup[] = [];
  private searched = false;

  get canDisplayResult() {
    return this.accounts && this.accounts.length > 0 && this.searched;
  }

  get canDisplayNoData() {
    return (!this.accounts || this.accounts.length <= 0) && this.searched;
  }

  get noDataText() {
    return this.$t('No {msg}', {
      msg: (this.$t('Account') as string).toLowerCase(),
    });
  }

  mounted() {
    this.handleSearch({} as IListAccountsRequest);
  }

  private async handleSearch($event: any) {
    const req: IListAccountsRequest = $event;

    AppModule.StartProgress();

    try {
      const res = await listAccounts(req);
      this.accounts = res.accounts;
    } catch (err) {
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.translateRouteTitle(
            this.$route.meta.title
          ) as string).toLowerCase(),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
    }

    try {
      const res = await listGroups({});
      this.groups = res.groups;
    } catch (err) {
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.$t('Fetch {msg}', {
            msg: this.$t('Group'),
          }) as string).toLowerCase(),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
    }

    this.searched = true;
    AppModule.StopProgress();
  }

  private translateRouteTitle(title: string) {
    return translateRouteTitle(this.$i18n, title);
  }
}
